import { render, staticRenderFns } from "./offlineversion.vue?vue&type=template&id=be52606a&scoped=true"
import script from "./offlineversion.vue?vue&type=script&lang=js"
export * from "./offlineversion.vue?vue&type=script&lang=js"
import style0 from "./offlineversion.vue?vue&type=style&index=0&id=be52606a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be52606a",
  null
  
)

export default component.exports